module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/fm-1579e5b6f7e79e7514451b61b5acd1e0.svg";